import { Component, Input, OnInit, HostListener, Renderer2, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { TimeEntryModel } from '../../../common/models/TimeEntry.model';
import { FormControl, FormGroup } from '@angular/forms';
import { getCurrentUser } from 'app/core/store/currentUser/user.selectors';
import { Store } from '@ngrx/store';
import { ConsultantModel } from '../../../common/models/consultant.model';
import { DateUtility } from '../../../common/utilities/date.utility';
import { SustainabilityEntryDialogComponent } from '../sustainability-entry-dialog/sustainability-entry-dialog.component';
import { GridApi } from 'ag-grid-community';
import { Constants } from '../../../common/utilities/constants.config';
import { getTimeDateRange } from 'app/core/store/timeDateRangeSelection/timeDateRangeSelection.selectors';
import { getExpenseDateRange } from 'app/core/store/expenseDateRangeSelection/expenseDateRangeSelection.selectors';
import { commonFunctions } from '../../../common/classes/common.class';
import { TimeEntryService } from '../../../common/services/time-entry.service';
import { PlanActualComparisionDialogComponent } from 'app/core/mips/actuals/time-entry/plan-actual-comparision-dialog/plan-actual-comparision-dialog.component';
import { SnackbarService } from '../../../common/services/snackbar.service';
import { EntryTableService } from '../../../common/services/entry-table.service';
import { FlagEntryService } from '../../../common/services/flag-entry.service';
import { setTimeDateRangeSelection } from 'app/core/store/timeDateRangeSelection/timeDateRangeSelection.actions';
import { DateRangeModel } from '../../../common/models/date-range.model';
import { DatePipe } from '@angular/common';
import { getTimeEntryGridConfig } from 'app/core/store/timeEntryGridConfig/timeEntryGridConfig.selector';
import { setTimeEntryGridConfig } from 'app/core/store/timeEntryGridConfig/timeEntryGridConfig.actions';
import { setExpenseDateRangeSelection } from 'app/core/store/expenseDateRangeSelection/expenseDateRangeSelection.actions';
import { ExpenseEntryService } from '../../../common/services/expense-entry.service';
import { ExpenseEntryModel } from '../../../common/models/ExpenseEntry.model';
import { setExpenseEntryGridConfig } from 'app/core/store/expenseEntryGridConfig/expenseEntryGridConfig.actions';
import { getExpenseEntryGridConfig } from 'app/core/store/expenseEntryGridConfig/expenseEntryGridConfig.selector';
import { WriteSilenceService } from '../../../common/services/write-silence.service';
import { Output, EventEmitter } from '@angular/core';
import { TransportModeService } from 'app/core/mips/common/services/transport-modes.service';
import { SustainabilityEntryService } from 'app/core/mips/common/services/sustainability-entry.service';
import { SustainabilityFlagService } from 'app/core/mips/common/services/sustainability-flag.service';
import { LocalStorageService } from 'app/core/mips/common/services/local-storage.service';
import { SustainabilityChartComponent } from '../sustainability-chart/sustainability-chart.component';
import { entries } from 'lodash';
import { FuseLoadingService } from '@fuse/services/loading';

@Component({
  selector: 'app-sustainability-entry-header',
  templateUrl: './sustainability-entry-header.component.html',
  styleUrls: ['./sustainability-entry-header.component.scss'],
})
export class SustainabilityEntryHeaderComponent implements OnInit, OnChanges {
  @Input() entryPageType: string;
  @Output() yearMonthSelectionChanged = new EventEmitter<{ year: number; month: string }[]>();
  @Output() saveClicked = new EventEmitter<void>();
  currentUserFirstName: string | null = null;
  @Input() isSaveEnabled: boolean = false;
  @Input() isResetEnabled: boolean = false;
  @Input() isFlagSubmitted: boolean = false;
  @Input() rowData: any[] = [];
  doubleClickedTravelIds: Set<number> = new Set();

  @Input() isSelectedforDeletion: boolean = false;
  yearRanges: { start: number; end: number; label: string }[] = [];
  @Output() resetTriggered = new EventEmitter<void>();
  private _editedEntries: any[] = [];
  @Input()
  set editedEntries(entries: any[]) {
    this._editedEntries = entries || [];
  }
  get editedEntries(): any[] {
    return this._editedEntries;
  }
  @Input() set sustainabilityData(data: any[]) {
    this.rowData = data || [];
    if (this.gridApi) {
      this.gridApi.setRowData(this.rowData);
    }
  }

  @Input() selectedYear: number | null = null;
  @Input() selectedMonth: string | null = null;

  @Input() chartData: { modeLabel: string; carbon: number; year: string; month: string }[] = [];
  transportModes: any[] = [];
  selectedYearMonthPairs: string[] = [];
  @Input() selectedTravelIds: Array<{ travel_id: number, month: number, year: number, mode?: string }> = [];
  entriesToSave: any[] = [];
  availableYears: number[] = [];
  currentYear: number;
  currentMonth: string;
  loginName: string | null = null;
  isSmallScreenFlag: boolean;
  isLargeScreenFlag: boolean;
  isUnsavedChangesPresent: boolean;
  isRowSelectedforDeletion: boolean;
  currentUser: ConsultantModel;
  entryTDate: any;
  weekStart: string = '';
  weekEnd: string = '';
  agGridAPI: GridApi;
  agGridColumnAPI: any;
  getDateRange: any;
  setDateRange: any;
  entryCountHashMap: any;
  dateEntryCountHashMap: any;
  actualsAndChangedEntries: TimeEntryModel[];
  plannedTimeEntries: TimeEntryModel[];
  deletedEntries = [];
  entryGridConfig: any;
  entryService: any;
  rowDragMode: boolean;
  setEntryGridConfiguration: any;
  getEntryGridConfiguration: any;
  entryModel: any;
  isWriteSilence: boolean;
  monthNumber: number;
  years: number[] = [];
  gridApi: any;
  onGridReady(params: any) {
    this.gridApi = params.api;
    if (this.rowData && this.rowData.length) {
      this.gridApi.setRowData(this.rowData);
    }
  }


  dateRange = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  @Output() entryAdded = new EventEmitter<any>();
  @Output() previousMonthCopied = new EventEmitter<void>();
  @Output() yearSelected = new EventEmitter<number>();
  @Output() monthSelected = new EventEmitter<string>();
  months = [
    { label: 'January', value: 1 },
    { label: 'February', value: 2 },
    { label: 'March', value: 3 },
    { label: 'April', value: 4 },
    { label: 'May', value: 5 },
    { label: 'June', value: 6 },
    { label: 'July', value: 7 },
    { label: 'August', value: 8 },
    { label: 'September', value: 9 },
    { label: 'October', value: 10 },
    { label: 'November', value: 11 },
    { label: 'December', value: 12 }
  ];


  constructor(

    private _store: Store,
    private _dialog: MatDialog,
    private _timeEntryService: TimeEntryService,
    private _expenseEntryService: ExpenseEntryService,
    private _snackBarService: SnackbarService,
    private _entryTableService: EntryTableService,
    private _flagEntryService: FlagEntryService,
    private _datePipe: DatePipe,
    private _writeSilenceService: WriteSilenceService,
    private _renderer: Renderer2,
    private travelEntryService: SustainabilityEntryService,
    private transportModeService: TransportModeService,
    private _fuseLoadingService: FuseLoadingService,
    private sustainabilityFlagService: SustainabilityFlagService
  ) {

    this.isSmallScreenFlag = false;
    this.isLargeScreenFlag = false;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  openSustainabilityDialog(): void {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;

    const dialogRef = this._dialog.open(SustainabilityEntryDialogComponent, {
      width: '400px',
      disableClose: true,
      data: {
        year: currentYear,
        month: currentMonth,
        existingRowData: this.rowData, // Pass current unsaved entries
        selectedMonths: this.selectedYearMonthPairs.map(pair => {
          const monthName = pair.split('-')[1];
          return this.getMonthOrderMap()[monthName] || null;
        }).filter(m => m)
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const mappedRows = result.transportDetails.map(item => ({
          ...item,
          unit: result.unit,
          year: item.year != null ? Number(item.year) : currentYear,
          month: item.month != null ? Number(item.month) : currentMonth,
          status: 'new',
        }));

        // Validate: prevent adding Daily entries for previous month after 15th
        // This restriction only applies to Daily travel type (this dialog always creates Daily entries)
        const today = new Date();
        const currentDay = today.getDate();

        if (currentDay > 15) {
          const currentMonth = today.getMonth() + 1; // 1-12
          const currentYear = today.getFullYear();

          // Calculate previous month
          let prevMonth = currentMonth - 1;
          let prevYear = currentYear;
          if (prevMonth === 0) {
            prevMonth = 12;
            prevYear = currentYear - 1;
          }

          // Check if any of the new Daily entries are for the previous month
          const hasPrevMonthDailyEntry = mappedRows.some(entry => {
            const entryMonth = Number(entry.month);
            const entryYear = Number(entry.year);

            return entryYear === prevYear && entryMonth === prevMonth;
          });

          if (hasPrevMonthDailyEntry) {
            this._snackBarService.showSnackBar(
              'Daily entries for the previous month cannot be added after the 15th of the current month.',
              null,
              'failure'
            );
            return; // Do not add entries to grid
          }
        }

        this.rowData = [...(this.rowData || []), ...mappedRows];
        this.isUnsavedChangesPresent = true;
        this.entryAdded.emit(result);
      }
    });
  }

  copyPreviousMonth(): void {
    this._snackBarService.showSnackBar(
      Constants.SNACKBAR_MSG_WAITING_FOR_API_RESPONSE,
      null,
      'info'
    );
    this.previousMonthCopied.emit();
  }

  openChartDashboard(): void {

    const dialogRef = this._dialog.open(SustainabilityChartComponent, {
      width: '800px',
      data: { formattedData: this.chartData },
      disableClose: false,

    });
    dialogRef.afterOpened().subscribe(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }
  onResetClicked() {
    this.resetTriggered.emit();
  }

  ngOnInit(): void {
    const today = new Date();

    // Current month
    const currentYear = today.getFullYear();
    const currentMonth = this.getMonthName(today.getMonth() + 1);
    const prevMonthDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);

    const prevYear = prevMonthDate.getFullYear();
    const prevMonth = this.getMonthName(prevMonthDate.getMonth() + 1);

    // Always show current and previous month in dropdown
    this.selectedYearMonthPairs = [
      `${prevYear}-${prevMonth}`,
      `${currentYear}-${currentMonth}`
    ];

    // Note: Do not emit yearMonthSelectionChanged on initial load as the parent
    // component already initializes the default months, preventing duplicate API calls.

    this.transportModeService.getTransportModes().subscribe((modes) => {
      this.transportModes = modes;
      this.transportModeService.setMap(modes);
    });

    this.selectedYear = currentYear;
    this.selectedMonth = currentMonth;
    this.yearSelected.emit(this.selectedYear);
    this.monthSelected.emit(this.selectedMonth);

    this.populateYears();
    this.years = Array.from({ length: 3 }, (_, i) => currentYear - i);


    this.checkScreenSize();
    switch (this.entryPageType) {
      case Constants.NAV_TIME_ENTRY_ACTUALS:
        this.getDateRange = getTimeDateRange;
        this.entryCountHashMap = this._timeEntryService.entryCountHashMap;
        this.setDateRange = setTimeDateRangeSelection;
        this.entryService = this._timeEntryService;
        this.setEntryGridConfiguration = setTimeEntryGridConfig;
        this.getEntryGridConfiguration = getTimeEntryGridConfig;
        this.entryModel = TimeEntryModel;
        break;
      case Constants.NAV_EXPENSE_ENTRY:
        this.getDateRange = getExpenseDateRange;
        this.setDateRange = setExpenseDateRangeSelection;
        this.entryService = this._expenseEntryService;
        this.entryCountHashMap = this._expenseEntryService.entryCountHashMap;
        this.setEntryGridConfiguration = setExpenseEntryGridConfig;
        this.getEntryGridConfiguration = getExpenseEntryGridConfig;
        this.entryModel = ExpenseEntryModel;
        break;
    }
    this._writeSilenceService.writeSilence.subscribe((data) => {
      this.isWriteSilence = data;
    });
    if (this.getDateRange) {
      this._store.select(this.getDateRange).subscribe((data) => {
        if (data) {
          this.weekStart = data['startDate'];
          this.weekEnd = data['endDate'];
        }
      });
    }
    if (this.entryService) {
      this.entryService.rowDragMode.subscribe((data) => {
        this.rowDragMode = data;
      });
      this.entryService.entryIsUnsavedChangesPresent.subscribe((data) => {
        this.isUnsavedChangesPresent = data;
      });
      this.entryService.entryisRowSelectedForDeletion.subscribe((data) => {
        this.isRowSelectedforDeletion = data;
      });

      this.entryService.entryCountHashMap.subscribe((data) => {
        this.dateEntryCountHashMap = data;
      });
    }
    this._store.select(getCurrentUser).subscribe((data) => {
      this.currentUser = data;
    });
    if (this.entryService) {
      this.entryService.entryActualsAndChanged.subscribe((data) => {
        this.actualsAndChangedEntries = data;
      });
      this.entryService.entryPlanned.subscribe((data) => {
        this.plannedTimeEntries = data;
      });
    }
    if (this.getEntryGridConfiguration) {
      this._store.select(this.getEntryGridConfiguration).subscribe((data) => {
        this.entryGridConfig = data;
      });
    }
    if (this.weekStart) {
      this.dateRange.get('start').setValue(new Date(this.weekStart));
    }
    if (this.weekEnd) {
      this.dateRange.get('end').setValue(new Date(this.weekEnd));
    }

    const element = document.querySelector(".mat-mdc-form-field.mat-form-field-appearance-fill .mat-mdc-form-field-subscript-wrapper");
    if (element) {
      this._renderer.setStyle(element, 'display', 'none', 1);
    }
  }
  generateYearRange(): number[] {
    const currentYear = new Date().getFullYear();
    return [currentYear - 1, currentYear, currentYear + 1];
  }


  populateYears(): void {
    const currentYear = new Date().getFullYear();
    this.availableYears = [];

    for (let i = 0; i < 5; i++) {
      this.availableYears.push(currentYear - i);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.checkScreenSize();

    if (changes['isSaveEnabled']) {
      this.isUnsavedChangesPresent = changes['isSaveEnabled'].currentValue;
    }

    if (changes['selectedYear'] && changes['selectedYear'].currentValue) {
      this.selectedYear = Number(changes['selectedYear'].currentValue);
    }

    if (changes['selectedMonth'] && changes['selectedMonth'].currentValue) {
      this.selectedMonth = String(changes['selectedMonth'].currentValue);
    }

    if (changes['selectedTravelIds'] && this.selectedTravelIds && this.selectedTravelIds.length > 0) {
      const first = this.selectedTravelIds[0];
      if (first.month && first.year) {
        this.selectedYear = Number(first.year);
        const monthNum = typeof first.month === 'number' ? first.month : (this.getMonthOrderMap()[first.month] || Number(first.month));
        this.selectedMonth = this.getMonthName(monthNum) || String(first.month);
        this.yearSelected.emit(this.selectedYear);
        this.monthSelected.emit(this.selectedMonth);
      }
    }

    if (changes['editedEntries']) {
      if (this.editedEntries && this.editedEntries.length > 0) {
        this.editedEntries.forEach(editedEntry => {
          const isUnsaved = !editedEntry.travel_id || editedEntry.travel_id === 0;

          const index = this.rowData.findIndex(row => {
            if (isUnsaved) {
              const matches = row.mode === editedEntry.mode &&
                row.month === editedEntry.month &&
                row.year === editedEntry.year;
              return matches;
            } else {
              return row.travel_id === editedEntry.travel_id;
            }
          });

          if (index !== -1) {
            this.rowData[index] = { ...this.rowData[index], ...editedEntry };
          }
        });
      }
    }

    switch (this.entryPageType) {
      case Constants.NAV_TIME_ENTRY_ACTUALS:
        this.getDateRange = getTimeDateRange;
        this.entryCountHashMap = this._timeEntryService.entryCountHashMap;
        this.setDateRange = setTimeDateRangeSelection;
        this.entryService = this._timeEntryService;
        this.setEntryGridConfiguration = setTimeEntryGridConfig;
        this.getEntryGridConfiguration = getTimeEntryGridConfig;
        this.entryModel = TimeEntryModel;
        break;

      case Constants.NAV_EXPENSE_ENTRY:
        this.getDateRange = getExpenseDateRange;
        this.setDateRange = setExpenseDateRangeSelection;
        this.entryService = this._expenseEntryService;
        this.entryCountHashMap = this._expenseEntryService.entryCountHashMap;
        this.setEntryGridConfiguration = setExpenseEntryGridConfig;
        this.getEntryGridConfiguration = getExpenseEntryGridConfig;
        this.entryModel = ExpenseEntryModel;
        break;
    }

    this._writeSilenceService.writeSilence.subscribe((data) => {
      this.isWriteSilence = data;
    });

    if (this.getDateRange) {
      this._store.select(this.getDateRange).subscribe((data) => {
        if (data) {
          this.weekStart = data['startDate'];
          this.weekEnd = data['endDate'];
        }
      });
    }

    if (this.getEntryGridConfiguration) {
      this._store.select(this.getEntryGridConfiguration).subscribe((data) => {
        this.entryGridConfig = data;
      });
    }

    if (this.entryService) {
      this.entryService.rowDragMode.subscribe((data) => {
        this.rowDragMode = data;
      });

      this.entryService.entryIsUnsavedChangesPresent.subscribe((data) => {
        this.isUnsavedChangesPresent = data;
      });

      this.entryService.entryisRowSelectedForDeletion.subscribe((data) => {
        this.isRowSelectedforDeletion = data;
      });

      this.entryService.entryCountHashMap.subscribe((data) => {
        this.dateEntryCountHashMap = data;
      });

      this.entryService.entryActualsAndChanged.subscribe((data) => {
        this.actualsAndChangedEntries = data;
      });

      this.entryService.entryPlanned.subscribe((data) => {
        this.plannedTimeEntries = data;
      });
    }

    this._store.select(getCurrentUser).subscribe((data) => {
      this.currentUser = data;
      if (data?.LoginName) {
        this.loginName = data.LoginName;
      }
    });
    if (this.weekStart) {
      this.dateRange.get('start').setValue(new Date(this.weekStart));
    }
    if (this.weekEnd) {
      this.dateRange.get('end').setValue(new Date(this.weekEnd));
    }

    const element = document.querySelector(".mat-mdc-form-field.mat-form-field-appearance-fill .mat-mdc-form-field-subscript-wrapper");
    if (element) {
      this._renderer.setStyle(element, 'display', 'none', 1);
    }

    if (changes['chartData']) {
      console.log('chartData received in header:', changes['chartData'].currentValue);
    }
  }

  onRowDoubleClicked(event) {
    const entry = event.data as any;
    if (entry.travel_id && entry.travel_id > 0) {
      this.doubleClickedTravelIds.add(entry.travel_id);
    }
  }

  setDateRangeSelection() {
    let confirmRedirect = false;
    if (this.isUnsavedChangesPresent) {
      confirmRedirect = window.confirm(Constants.MSG_CONFIRM_DISCARD_CHANGES)
    }
    if (!this.isUnsavedChangesPresent || (this.isUnsavedChangesPresent && confirmRedirect)) {
      let week = new DateRangeModel();
      week['startDate'] = this._datePipe.transform(
        this.dateRange.value.start,
        'dd MMM yyyy'
      );
      week['endDate'] = this._datePipe.transform(
        this.dateRange.value.end,
        'dd MMM yyyy'
      );
      if (
        this.weekStart != week['startDate'] ||
        this.weekEnd != week['endDate']
      ) {
        if (week['endDate'] == null) {
          week['endDate'] = week['startDate']
          this.dateRange.get('end').setValue(new Date(week['endDate']));
        }
        this._store.dispatch(this.setDateRange({ week: week }));
      }
    }
    else {
      this.dateRange.get('start')?.setValue(new Date(this.weekStart));
      this.dateRange.get('end')?.setValue(new Date(this.weekEnd));
    }
  }

  setDateEntryCountHashMap(dateEntryCountHashMap) {
    this.entryService.entryCountHashMap.next(dateEntryCountHashMap);
  }

  setEntryIsUnsavedChangesPresent(isUnsavedChangesPresent) {
    this.entryService.entryIsUnsavedChangesPresent.next(
      isUnsavedChangesPresent
    );
  }

  setEntryGridConfig(entryGridConfig) {
    this._store.dispatch(this.setEntryGridConfiguration({ entryGridConfig }));
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isSmallScreenFlag = window.innerWidth < 768;
    this.isLargeScreenFlag = !this.isSmallScreenFlag;
  }

  isSmallScreen(): boolean {
    return this.isSmallScreenFlag;
  }

  isLargeScreen(): boolean {
    return this.isLargeScreenFlag;
  }

  @Output() travelIdsDeleted = new EventEmitter<Array<{ travel_id: number, month: number, year: number, mode?: string }>>();

  getEffectiveLoginName(): string {
    if (this.currentUser?.LoginName) {
      return this.currentUser.LoginName;
    }
    if (this.loginName) {
      return this.loginName;
    }
    try {
      const userDataStr = LocalStorageService.getLocalStorageValueBasedOnKeys('currentUser');
      if (userDataStr) {
        const userData = JSON.parse(userDataStr);
        return userData?.currentUser?.LoginName || userData?.LoginName || '';
      }
    } catch (e) {
    }
    return '';
  }

  deleteButtonClicked() {
    if (!this.selectedTravelIds.length) return;

    const flagCompletionEntries = this.selectedTravelIds.filter((entry: any) => entry.isCompletionRow);
    const regularEntries = this.selectedTravelIds.filter((entry: any) => !entry.isCompletionRow);

    // If flag completion row is selected, enforce deletion deadline (on or before 15th of following month)
    if (flagCompletionEntries.length > 0) {
      const hasLockedFlag = flagCompletionEntries.some((entry: any) =>
        !this.isFlagDeletionAllowed(Number(entry.year), Number(entry.month))
      );
      if (hasLockedFlag) {
        this._snackBarService.showSnackBar(
          'Flag completion records cannot be deleted after the 15th of the following month.',
          null,
          'failure'
        );
        return;
      }
    }

    // Validate regular entries editing deadline
    if (regularEntries.length > 0) {
      const hasLockedEntry = regularEntries.some(entry =>
        !this.isEntryEditable(Number(entry.year), Number(entry.month))
      );
      if (hasLockedEntry) {
        this._snackBarService.showSnackBar(
          'Entries for the previous month cannot be edited after the 15th of the current month.',
          null,
          'failure'
        );
        return;
      }
    }

    const effectiveLogin = this.getEffectiveLoginName();

    // Process flag completion deletion
    if (flagCompletionEntries.length > 0) {
      flagCompletionEntries.forEach((flagEntry: any) => {
        const loginForDelete = flagEntry.employeeId || effectiveLogin;
        const monthStr = flagEntry.month.toString().padStart(2, '0');
        const yearStr = flagEntry.year.toString();
        this.sustainabilityFlagService.deleteFlag(loginForDelete, monthStr, yearStr).subscribe({
          next: (res) => {
            this._snackBarService.showSnackBar(
              res?.message || 'Flag completion record deleted successfully.',
              null,
              'success'
            );
            this.travelIdsDeleted.emit([flagEntry]);
          },
          error: (err) => {
            console.error('Error deleting flag:', err);
            this._snackBarService.showSnackBar(
              err.error?.error || err.error?.message || Constants.SNACKBAR_MSG_ENTRY_DELETE_FALIED,
              'close',
              'failure'
            );
          }
        });
      });
    }

    if (regularEntries.length === 0) {
      this.selectedTravelIds = [];
      return;
    }

    const backendDeletesByMonthYear = new Map<string, number[]>();
    const frontendDeletes: any[] = [];

    for (const entry of regularEntries) {
      if (entry.travel_id && entry.travel_id > 0) {
        const month = Number(entry.month);
        const year = Number(entry.year);
        const key = `${year}-${month}`;

        if (!backendDeletesByMonthYear.has(key)) {
          backendDeletesByMonthYear.set(key, []);
        }
        backendDeletesByMonthYear.get(key)!.push(entry.travel_id);
      } else {
        // Unsaved entry
        frontendDeletes.push(entry);
      }
    }

    if (backendDeletesByMonthYear.size === 0 && frontendDeletes.length === 0) {
      this._snackBarService.showSnackBar(
        'Could not find selected rows for deletion.',
        null,
        'failure'
      );
      return;
    }

    this._snackBarService.showSnackBar(
      Constants.SNACKBAR_MSG_SAVING_CHANGES,
      null,
      'info'
    );

    const finalizeDeletes = () => {
      const deletedEntries = regularEntries.map(entry => ({
        travel_id: entry.travel_id,
        month: Number(entry.month),
        year: Number(entry.year),
        mode: entry.mode
      }));

      // For edited entries filter
      const deletedIds = this.selectedTravelIds
        .filter(e => e.travel_id && e.travel_id > 0)
        .map(e => e.travel_id);

      this.editedEntries = (this.editedEntries || []).filter(e => !deletedIds.includes(e.travel_id));

      this.travelIdsDeleted.emit(deletedEntries);
      this.selectedTravelIds = [];

      this._snackBarService.showSnackBar(
        Constants.SNACKBAR_MSG_ENTRY_DELETION,
        '',
        'success'
      );
    };

    if (backendDeletesByMonthYear.size > 0) {
      const deleteRequests = Array.from(backendDeletesByMonthYear.entries()).map(([key, travelIds]) => {
        const [year, month] = key.split('-').map(Number);
        return this.travelEntryService.deleteEntries(travelIds, month, year, this.loginName);
      });

      let successCount = 0;
      let errorCount = 0;

      const executeDeletes = (index: number) => {
        if (index >= deleteRequests.length) {
          if (errorCount > 0) {
            this._snackBarService.showSnackBar(
              Constants.SNACKBAR_MSG_ENTRY_DELETE_FALIED,
              'close',
              'failure'
            );
          } else {
            finalizeDeletes();
          }
          return;
        }

        deleteRequests[index].subscribe({
          next: (res: any) => {
            if (res && res.result === false) {
              errorCount++;
              console.error(`Failed to delete batch at index ${index}:`, res.Message || res.message);
              this._snackBarService.showSnackBar(
                res.Message || res.message || Constants.SNACKBAR_MSG_ENTRY_DELETE_FALIED,
                'close',
                'failure'
              );
            } else {
              successCount++;
            }
            executeDeletes(index + 1);
          },
          error: (err: any) => {
            errorCount++;
            console.error(`Failed to delete batch at index ${index}:`, err);
            executeDeletes(index + 1);
          }
        });
      };

      executeDeletes(0);
    } else {
      // Only frontend deletes
      finalizeDeletes();
    }
  }

  isFlagDeletionAllowed(year: number, month: number): boolean {
    if (!year || !month || isNaN(year) || isNaN(month)) {
      return false;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const deadline = new Date(year, month, 15);
    deadline.setHours(23, 59, 59, 999);

    return today <= deadline;
  }

  private isEntryEditable(year: number, month: number): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const deadline = new Date(year, month, 15);
    deadline.setHours(0, 0, 0, 0);

    return today <= deadline;
  }


  // Reset Data
  resetChangesButtonClicked(): void {
    const confirmReset = window.confirm(
      Constants.MSG_CONFIRM_RESET_ENTRY
    );
    if (confirmReset) {
      this._entryTableService.getEntryTableEntries(
        this.entryService.getGridApi(),
        this.entryPageType
      );
    }
  }
  resetColumnsButtonClicked(): void {
    let tempEntryGridConfig = { ...this.entryGridConfig };
    this.agGridColumnAPI = this.entryService.getGridColumnApi();
    if (!commonFunctions.isNullOrUndefined(this.agGridColumnAPI)) {
      this.agGridColumnAPI.resetColumnState();
      if (
        !commonFunctions.isNullOrUndefined(tempEntryGridConfig) &&
        tempEntryGridConfig.id !== 0
      ) {
        tempEntryGridConfig.Configuration = JSON.stringify(
          this.agGridColumnAPI.getColumnState()
        );
        this.setEntryGridConfig(tempEntryGridConfig);
      }
    }
    this.entryService.setGridColumnApi(this.agGridColumnAPI);
  }

  toggleValueChanged() {
    this.entryService.rowDragMode.next(!this.rowDragMode);
  }


  onSave() {
    if (this.isSaving) {
      console.warn('[SAVE BLOCKED] Save already in progress.');
      return;
    }

    this._snackBarService.showSnackBar(
      Constants.SNACKBAR_MSG_SAVING_CHANGES,
      null,
      'info'
    );
    this.isSaving = true;
    this._fuseLoadingService.show();
    this.onSaveClicked();
  }

  @Output() saveSuccessful = new EventEmitter<void>();
  @Output() copiedRowAdded = new EventEmitter<any>();
  @Output() newRowsSaved = new EventEmitter<any[]>();

  isSaving: boolean = false;

  addCopiedRow(row: any) {
    const copied = {
      travel_id: 0,
      mode: row.mode,
      unit: row.unit,
      distance: row.distance,
      commutingDays: row.commutingDays,
      plane_origin_desc: row.plane_origin_desc || null,
      plane_destination_desc: row.plane_destination_desc || null,
      plane_frequency: row.plane_frequency || null,
      year: row.year != null ? Number(row.year) : this.selectedYear,
      month: row.month != null ? Number(row.month) : (this.getMonthOrderMap()[this.selectedMonth] || Number(this.selectedMonth)),
      status: 'new'
    };

    const existingNewEntries = this.rowData.filter(r => r.status === 'new');
    this.rowData = [...existingNewEntries, copied];

    this.isSaveEnabled = this.rowData.some(r => r.status === 'new' || r.status === 'modified');
  }


  onSaveClicked() {

    const userDataStr = LocalStorageService.getLocalStorageValueBasedOnKeys('currentUser');
    let currentUserFirstName: string | null = null;
    let currentUserCountry: string | null = null;
    let currentUserLoginName: string | null = null;

    if (userDataStr) {
      try {
        const userData = JSON.parse(userDataStr);
        currentUserFirstName = userData?.currentUser?.Employee || null;
        currentUserLoginName = userData?.currentUser?.LoginName || null;
        currentUserCountry = userData?.currentUser?.Country_Description || null;
      } catch (e) {
        console.error('[ERROR] Failed to parse user data from localStorage', e);
      }
    }

    const monthNameToNumber: { [key: string]: number } = {
      January: 1, February: 2, March: 3,
      April: 4, May: 5, June: 6,
      July: 7, August: 8, September: 9,
      October: 10, November: 11, December: 12
    };
    this.rowData = this.rowData.map(r => {
      const monthValue = isNaN(Number(r.month))
        ? monthNameToNumber[r.month] || r.month
        : Number(r.month);
      return { ...r, month: monthValue };
    });

    this.editedEntries = this.editedEntries.map(r => {
      const monthValue = isNaN(Number(r.month))
        ? monthNameToNumber[r.month] || r.month
        : Number(r.month);
      return { ...r, month: monthValue };
    });
    const monthsToCheck = new Set<string>();

    (this.rowData || []).forEach(r => {
      const ry = r && r.year != null ? Number(r.year) : null;
      const rm = r && r.month != null ? Number(r.month) : null;
      if (ry != null && rm != null) {
        monthsToCheck.add(`${ry}-${String(rm).padStart(2, '0')}`);
      }
    });
    (this.editedEntries || []).forEach(r => {
      const ry = r && r.year != null ? Number(r.year) : null;
      const rm = r && r.month != null ? Number(r.month) : null;
      if (ry != null && rm != null) {
        monthsToCheck.add(`${ry}-${String(rm).padStart(2, '0')}`);
      }
    });

    if (this.selectedYear && this.selectedMonth) {
      const monthOrder = this.getMonthOrderMap();
      const selMonthNum = monthOrder[this.selectedMonth] || Number(this.selectedMonth);
      monthsToCheck.add(`${this.selectedYear}-${String(selMonthNum).padStart(2, '0')}`);
    }

    this.travelEntryService.getSustainabilityData(Array.from(monthsToCheck), currentUserLoginName!).subscribe({
      next: (backendEntries) => {
        // Filter backend entries to only include Daily travel type
        const dailyBackendEntries = backendEntries.filter(e => e.travel_type_desc === 'Daily');

        const activeEntries = (this.rowData || []).filter(r =>
          !r.isBannerRow &&
          !r.isBlank &&
          !r.isCompletionRow &&
          (!r.travel_type_desc || r.travel_type_desc === 'Daily')
        );

        const editedMap = new Map<number, any>();
        (this.editedEntries || []).forEach(e => {
          if (e.travel_id && e.travel_id !== 0) {
            editedMap.set(e.travel_id, e);
          }
        });

        const modesByMonth = new Map<string, Set<string>>();
        let hasDuplicate = false;

        for (const r of activeEntries) {
          const monthKey = `${Number(r.year)}-${Number(r.month)}`;
          const effectiveMode = (r.travel_id && editedMap.has(r.travel_id)
            ? editedMap.get(r.travel_id).mode
            : r.mode) || '';
          const modeNormalized = effectiveMode.trim().toLowerCase();

          if (!modeNormalized) continue;

          if (!modesByMonth.has(monthKey)) {
            modesByMonth.set(monthKey, new Set<string>());
          }

          const monthModes = modesByMonth.get(monthKey)!;
          if (monthModes.has(modeNormalized)) {
            hasDuplicate = true;
            console.warn('[DUPLICATE] Duplicate transport mode detected in month:', monthKey, modeNormalized);
            break;
          }
          monthModes.add(modeNormalized);
        }

        if (!hasDuplicate) {
          const rowDataTravelIds = new Set(
            activeEntries.filter(r => r.travel_id && r.travel_id !== 0).map(r => r.travel_id)
          );

          for (const be of dailyBackendEntries) {
            if (!rowDataTravelIds.has(be.travel_id)) {
              const monthKey = `${Number(be.year)}-${Number(be.month)}`;
              const modeNormalized = (be.transportmode_desc || '').trim().toLowerCase();
              if (!modeNormalized) continue;

              if (!modesByMonth.has(monthKey)) {
                modesByMonth.set(monthKey, new Set<string>());
              }
              const monthModes = modesByMonth.get(monthKey)!;
              if (monthModes.has(modeNormalized)) {
                hasDuplicate = true;
                console.warn('[DUPLICATE] Duplicate transport mode with backend entry:', monthKey, modeNormalized);
                break;
              }
              monthModes.add(modeNormalized);
            }
          }
        }

        if (hasDuplicate) {
          this._snackBarService.showSnackBar(
            "Duplicate entry not allowed. Two entries cannot have the same transport mode in the same month.",
            null,
            'failure'
          );
          this.isSaving = false;
          this._fuseLoadingService.hide();
          return;
        }

        this.rowData.filter(r => !r.isBannerRow && !r.isBlank).forEach((r, index) => {

        });

        this.editedEntries.forEach((r, index) => {

        });

        const entryMap = new Map<number, any>();
        this.rowData
          .filter(r => !r.isBannerRow && !r.isBlank)
          .forEach(r => {
            if (r.travel_id && r.travel_id !== 0) {
              entryMap.set(r.travel_id, r);
            }
          });

        this.editedEntries.forEach(e => {
          if (e.travel_id && e.travel_id !== 0) {
            const existing = entryMap.get(e.travel_id);
            if (!existing) {
              entryMap.set(e.travel_id, e);
            } else {
              entryMap.set(e.travel_id, e);
            }
          }
        });

        const editedModesSet = new Set(
          this.editedEntries
            .filter(e => e.travel_id && e.travel_id !== 0)
            .map(e => `${e.mode.toLowerCase()}-${Number(e.month)}-${Number(e.year)}`)
        );

        const entriesToSave = this.rowData
          .filter(r => !r.isBannerRow && !r.isBlank)
          .filter(r => {
            if (r.status === 'edited' && r.travel_id && r.travel_id !== 0) {
              return false;
            }

            const isNew = r.status === 'new' || r.status === 'modified' || (!r.travel_id || r.travel_id === 0);
            const entryKey = `${r.mode.toLowerCase()}-${Number(r.month)}-${Number(r.year)}`;
            const isDuplicateOfEditedEntry = editedModesSet.has(entryKey);
            const isAlreadyUpdated = r.travel_id && entryMap.has(r.travel_id);

            if (isDuplicateOfEditedEntry || isAlreadyUpdated) {
              return false;
            }

            if (isNew) {
            }
            return isNew;
          })
          .map(r => ({
            travel_id: 0,
            login_name: currentUserLoginName,
            office_desc: currentUserCountry,
            attendance_per_week: r.commutingDays,
            distance_unit: r.unit,
            transportmode_desc: r.mode,
            distance: Number(r.transport_mode_id) === 16 ? 0 : r.distance,
            plane_origin_desc: r.plane_origin_desc || null,
            plane_destination_desc: r.plane_destination_desc || null,
            plane_frequency: r.mode === 'Plane'
              ? ((r?.is_roundtrip != null ? Number(r.is_roundtrip) : r?.RoundTrip != null ? (r.RoundTrip ? 1 : 0) : 0) === 1 ? 2 : 1)
              : null,
            is_roundtrip:
              r?.is_roundtrip != null ? Number(r.is_roundtrip) :
                r?.RoundTrip != null ? (r.RoundTrip ? 1 : 0) :
                  0,
            travel_type_desc: "Daily",
            month: Number(r.month),
            year: Number(r.year),
            ...(Number(r.transport_mode_id) === 16 ? {
              transport_mode_id: 16,
              carbon_emission: 0
            } : {})
          }));

        const entriesToUpdate = Array.from(entryMap.values())
          .filter(r => {
            const shouldUpdate = (r.status === 'modified' || r.status === 'edited') && r.travel_id && r.travel_id !== 0;
            if (shouldUpdate) {
            }
            return shouldUpdate;
          })
          .map(r => ({
            travel_id: r.travel_id,
            login_name: currentUserLoginName,
            office_desc: currentUserCountry,
            attendance_per_week: r.commutingDays,
            distance_unit: r.unit,
            transportmode_desc: r.mode,
            distance: Number(r.transport_mode_id) === 16 ? 0 : r.distance,
            plane_origin_desc: r.plane_origin_desc || null,
            plane_destination_desc: r.plane_destination_desc || null,
            plane_frequency: r.mode === 'Plane'
              ? ((r?.is_roundtrip != null ? Number(r.is_roundtrip) : r?.RoundTrip != null ? (r.RoundTrip ? 1 : 0) : 0) === 1 ? 2 : 1)
              : null,
            is_roundtrip:
              r?.is_roundtrip != null ? Number(r.is_roundtrip) :
                r?.RoundTrip != null ? (r.RoundTrip ? 1 : 0) :
                  0,
            travel_type_desc: "Daily",
            month: Number(r.month),
            year: Number(r.year),
            ...(Number(r.transport_mode_id) === 16 ? {
              transport_mode_id: 16,
              carbon_emission: 0
            } : {})
          }));
        let postCompleted = entriesToSave.length === 0;
        let putCompleted = entriesToUpdate.length === 0;

        const checkCompletion = () => {
          if (postCompleted && putCompleted) {
            this.isSaving = false;
            this._fuseLoadingService.hide();
            this.editedEntries = [];
            this._snackBarService.showSnackBar(Constants.SNACKBAR_MSG_ENTRY_SUCCESSFUL, '', 'success');
            this.saveSuccessful.emit();
          }
        };

        if (entriesToSave.length > 0) {
          this.travelEntryService.saveEntries(entriesToSave).subscribe({
            next: (response: any) => {
              if (response && response.result === false) {
                this.isSaving = false;
                this._fuseLoadingService.hide();
                this._snackBarService.showSnackBar(
                  response.Message || response.message || Constants.SNACKBAR_MSG_ENTRY_SAVE_FALIED,
                  'close',
                  'failure'
                );
                return;
              }
              this.newRowsSaved.emit(response);
              postCompleted = true;
              checkCompletion();
            },
            error: (err) => {
              this.isSaving = false;
              this._fuseLoadingService.hide();
              this._snackBarService.showSnackBar(Constants.SNACKBAR_MSG_ENTRY_SAVE_FALIED, 'close', 'failure');
            }
          });
        }

        if (entriesToUpdate.length > 0) {
          const groups = new Map<string, any[]>();
          entriesToUpdate.forEach(e => {
            const key = `${Number(e.year)}-${String(Number(e.month)).padStart(2, '0')}`;
            if (!groups.has(key)) groups.set(key, []);
            groups.get(key).push(e);
          });

          let pendingPuts = groups.size;
          putCompleted = pendingPuts === 0;

          groups.forEach((groupEntries, key) => {
            this.travelEntryService.updateMultipleEntries(groupEntries).subscribe({
              next: (response: any) => {
                if (response && response.result === false) {
                  this.isSaving = false;
                  this._fuseLoadingService.hide();
                  this._snackBarService.showSnackBar(
                    response.Message || response.message || Constants.SNACKBAR_MSG_ENTRY_SAVE_FALIED,
                    'close',
                    'failure'
                  );
                  return;
                }
                pendingPuts -= 1;
                if (pendingPuts === 0) {
                  putCompleted = true;
                  checkCompletion();
                }
              },
              error: (err) => {
                console.error(`[PUT ERROR] Update failed for ${key}:`, err);
                this.isSaving = false;
                this._fuseLoadingService.hide();
                this._snackBarService.showSnackBar(Constants.SNACKBAR_MSG_ENTRY_SAVE_FALIED, 'close', 'failure');
              }
            });
          });
        }

        if (entriesToSave.length === 0 && entriesToUpdate.length === 0) {

          this._snackBarService.showSnackBar('No changes to save', null, 'info');
          this.isSaving = false;
          this._fuseLoadingService.hide();
        }
      },
      error: (err) => {
        console.error('[FETCH ERROR] Failed to fetch sustainability data for duplicate check', err);
        this._snackBarService.showSnackBar(Constants.SNACKBAR_MSG_ENTRY_SAVE_FALIED, 'close', 'failure');
        this.isSaving = false;
        this._fuseLoadingService.hide();
      }
    });
  }


  getYearMonthValue(year: number, monthLabel: string): string {
    return `${year}-${monthLabel}`;
  }
  getMonthName(month: number): string {
    const monthNames = [
      '', 'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return monthNames[month];
  }

  getMonthOrderMap(): { [key: string]: number } {
    return {
      January: 1, February: 2, March: 3,
      April: 4, May: 5, June: 6,
      July: 7, August: 8, September: 9,
      October: 10, November: 11, December: 12
    };
  }

  isFutureTimePeriod(year: number, monthValue: number): boolean {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    const selectedIndex = Number(year) * 12 + Number(monthValue);
    const currentIndex = currentYear * 12 + currentMonth;
    return selectedIndex > currentIndex;
  }

  getMonthsForYear(year: number): { label: string; value: number }[] {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;

    if (Number(year) > currentYear) {
      return [];
    }
    if (Number(year) === currentYear) {
      return this.months.filter(m => m.value <= currentMonth);
    }
    return this.months;
  }

  onYearMonthChange(selectedValues: string[]): void {
    const monthOrder = this.getMonthOrderMap();

    // Prevent selection of any future time periods
    selectedValues = (selectedValues || []).filter(val => {
      const [year, monthName] = val.split('-');
      const monthNum = monthOrder[monthName];
      return !this.isFutureTimePeriod(Number(year), monthNum);
    });

    // Identify newly selected value if any
    const newlySelected = selectedValues.find(v => !this.selectedYearMonthPairs.includes(v));

    const sorted = selectedValues.sort((a, b) => {
      const [yearA, monthA] = a.split('-');
      const [yearB, monthB] = b.split('-');

      const comp = Number(yearA) - Number(yearB);
      return comp !== 0
        ? comp
        : monthOrder[monthA] - monthOrder[monthB];
    });

    this.selectedYearMonthPairs = sorted;

    if (newlySelected) {
      const [year, month] = newlySelected.split('-');
      this.selectedYear = Number(year);
      this.selectedMonth = month;
      this.yearSelected.emit(this.selectedYear);
      this.monthSelected.emit(this.selectedMonth);
    } else if (sorted.length > 0) {
      // If current selection is still in sorted list, keep it; otherwise use the first
      const stillInList = sorted.some(pair => {
        const [year, month] = pair.split('-');
        return Number(year) === this.selectedYear && month === this.selectedMonth;
      });
      if (!stillInList) {
        const [year, month] = sorted[0].split('-');
        this.selectedYear = Number(year);
        this.selectedMonth = month;
        this.yearSelected.emit(this.selectedYear);
        this.monthSelected.emit(this.selectedMonth);
      }
    }

    this.emitSelection();
  }

  onMonthOptionClicked(year: number, monthLabel: string): void {
    this.selectedYear = Number(year);
    this.selectedMonth = monthLabel;
    this.yearSelected.emit(this.selectedYear);
    this.monthSelected.emit(this.selectedMonth);
  }

  isConsecutiveMonths(months: string[], monthOrder: { [key: string]: number }): boolean {
    for (let i = 1; i < months.length; i++) {
      const [prevYear, prevMonth] = months[i - 1].split('-');
      const [currYear, currMonth] = months[i].split('-');
      const prevIndex = (+prevYear * 12) + (monthOrder[prevMonth] - 1);
      const currIndex = (+currYear * 12) + (monthOrder[currMonth] - 1);
      if (currIndex - prevIndex !== 1) {
        return false;
      }
    }
    return true;
  }

  emitSelection(): void {
    const result = this.selectedYearMonthPairs.map(pair => {
      const [year, month] = pair.split('-');
      return { year: +year, month };
    });
    this.yearMonthSelectionChanged.emit(result);
  }
}
